<div class="panel-shell">
  <header class="panel-header">
    <div class="panel-title text-bold" *ngIf="mode === 'CREATE'">
      {{ "LABOUR_CHARGE.TITLE" | translate }}
    </div>
    <div class="panel-title text-bold" *ngIf="mode === 'EDIT'">
      {{ "LABOUR_CHARGE.EDIT_TITLE" | translate }}
    </div>
    <button
      mat-icon-button
      type="button"
      class="panel-close-btn"
      (click)="close()"
      aria-label="Close panel"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="panel-body">
    <div class="flex-column-center-start">
      <div class="item-full-width flex-column-start-start">
        <app-gt2-select
          *ngIf="mode === 'CREATE'"
          [service]="labourChargeService"
          [placeHolder]="'LABOUR_CHARGE.SELECT_LABOUR_CHARGE' | translate"
          [label]="''"
          [selectedModel]="selectedLabourCharge"
          (changeEvent)="onLabourChargeChange($event)"
          [noResultsLabel]="translate.instant('GENERIC.NO_RESULTS')"
          [nullableUseNone]="false"
          class="item-full-width fxFlex-100p"
        ></app-gt2-select>
        <div *ngIf="mode === 'EDIT'" class="labour-charge-name ml-4">
          {{ labourChargeToUpdate.name }}
        </div>
      </div>

      <div
        *ngIf="mode === 'EDIT'"
        class="item-full-width flex-column fxFlex-100p"
      >
        <div
          [formGroup]="form"
          (keyup.enter)="
            form.valid &&
            !loading &&
            labourChargeToUpdate.from_time !== 'Invalid DateTime' &&
            labourChargeToUpdate.to_time !== 'Invalid DateTime'
              ? onSubmitLabourCharge()
              : null
          "
        >
          <mat-form-field class="item-full-width fxFlex-50p">
            <mat-label>{{ "GENERIC.PRICE" | translate }}</mat-label>
            <input
              matInput
              type="text"
              autocomplete="nope"
              formControlName="unit_price"
              pattern="^[+-]?[0-9]+([.,][0-9]{1,2})?"
              [(ngModel)]="labourChargeToUpdate.unit_price"
              required
            />
            <mat-error *ngIf="form.controls['unit_price'].invalid">
              {{ "GENERIC.INPUT_NUMBER_0_999999" | translate }}
            </mat-error>
          </mat-form-field>

          <mat-form-field class="item-full-width fxFlex-50p">
            <mat-label>{{ "GENERIC.QUANTITY" | translate }}</mat-label>
            <input
              matInput
              type="text"
              autocomplete="nope"
              formControlName="qty"
              pattern="^[+-]?[0-9]+([.,][0-9]{1,2})?"
              [(ngModel)]="labourChargeToUpdate.qty"
              required
            />
            <mat-error *ngIf="form.controls['qty'].invalid">
              {{ "GENERIC.INPUT_NUMBER_0_999999" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <!-- FROM, TO -->
        <div class="item-full-width flex-row-start-start fxFlex-100p">
          <div [formGroup]="form" class="flex-column-center-start fxFlex-50p">
            <mat-form-field class="item-full-width mr-8 fxFlex-100p">
              <mat-label>{{ "GENERIC.DATE_START" | translate }}</mat-label>
              <input
                matInput
                [matDatepicker]="fromDate"
                [(ngModel)]="labourChargeToUpdate.from_date"
                min="1900-01-01"
                formControlName="from_date"
                required
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="fromDate"
              ></mat-datepicker-toggle>
              <mat-datepicker #fromDate></mat-datepicker>
              <mat-error *ngIf="form.controls['from_date'].invalid"
                >{{ "GENERIC.DATE_DEFAULT_RANGE_INVALID" | translate }}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="item-full-width mr-8 fxFlex-100p">
              <mat-label>{{ "GENERIC.DATE_END" | translate }}</mat-label>
              <input
                matInput
                [matDatepicker]="toDate"
                [(ngModel)]="labourChargeToUpdate.to_date"
                min="1900-01-01"
                formControlName="to_date"
                required
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="toDate"
              ></mat-datepicker-toggle>
              <mat-datepicker #toDate></mat-datepicker>

              <mat-error *ngIf="form.controls['to_date'].invalid"
                >{{ "GENERIC.DATE_DEFAULT_RANGE_INVALID" | translate }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex-column-center-start fxFlex-50p">
            <div
              class="item-full-width ml-8 ngx-timepicker-field-from fxFlex-100p"
            >
              <div class="timepicker-custom-label">
                {{ "GENERIC.TIME" | translate }}*
              </div>
              <ngx-timepicker-field
                [buttonAlign]="'left'"
                [format]="24"
                [(ngModel)]="labourChargeToUpdate.from_time"
                class="ngx-material-timepicker-toggle"
              >
              </ngx-timepicker-field>
            </div>

            <div class="item-full-width ml-8 ngx-timepicker-field-to fxFlex-100p">
              <div class="timepicker-custom-label">
                {{ "GENERIC.TIME" | translate }}*
              </div>
              <ngx-timepicker-field
                [buttonAlign]="'left'"
                [format]="24"
                [(ngModel)]="labourChargeToUpdate.to_time"
                class="ngx-material-timepicker-toggle"
              >
              </ngx-timepicker-field>
            </div>
          </div>
        </div>

        <p-editor
          #noteEditor
          [(ngModel)]="labourChargeToUpdate.note"
          [style]="{
            height: '120px',
            width: '100%',
            resize: 'vertical',
            overflow: 'auto',
          }"
        >
          <ng-template pTemplate="header" class="">
            <span class="ql-formats">
              <button class="ql-bold"></button>
              <button class="ql-italic"></button>
              <button class="ql-underline"></button>
              <button class="ql-strike"></button>
            </span>

            <span class="ql-formats">
              <select class="ql-color"></select>
              <select class="ql-background"></select>
            </span>

            <span class="ql-formats">
              <button class="ql-list" value="ordered"></button>
              <button class="ql-list" value="bullet"></button>
              <button class="ql-indent" value="-1"></button>
              <button class="ql-indent" value="+1"></button>
            </span>

            <span class="ql-formats">
              <app-emoji-picker-button
                [editor]="noteEditor"
              ></app-emoji-picker-button>
            </span>
          </ng-template>
        </p-editor>
      </div>
    </div>

    <div *ngIf="loading" class="flex-row-center-start">
      <mat-spinner [diameter]="40" class="mt-20"></mat-spinner>
    </div>
  </div>

  <footer class="panel-footer gt2-buttons-theme flex-row-center-center">
    <button
      *ngIf="mode === 'CREATE'"
      mat-raised-button
      [disabled]="!selectedLabourCharge || loading"
      color="accent"
      class="mr-8 ml-8 mt-4 mb-4"
      (click)="onSubmitLabourCharge()"
    >
      {{ "GENERIC.SAVE" | translate }}
    </button>

    <button
      *ngIf="mode === 'CREATE'"
      mat-stroked-button
      [disabled]="!selectedLabourCharge || loading"
      class="mr-8 mt-4 mb-4"
      (click)="onSubmitLabourCharge(true)"
    >
      {{ "LABOUR_CHARGE.CREATE_AND_ADD" | translate }}
    </button>

    <button
      *ngIf="mode === 'EDIT'"
      mat-raised-button
      [disabled]="
        form.invalid ||
        labourChargeToUpdate.from_time === 'Invalid DateTime' ||
        labourChargeToUpdate.to_time === 'Invalid DateTime' ||
        loading
      "
      color="accent"
      class="mr-8 ml-8 mt-4 mb-4"
      (click)="onSubmitLabourCharge()"
    >
      {{ "GENERIC.SAVE" | translate }}
    </button>

    <button
      mat-raised-button
      color="primary"
      (click)="close()"
      class="mr-8 ml-8 mt-4 mb-4"
    >
      {{ "GENERIC.CANCEL" | translate }}
    </button>
  </footer>
</div>
